import { Chip } from "@mui/material";
import {
  formatPaymentStatus,
  getColorByPaymentStatus,
} from "../helpers/format";

const PaymentStatusTag = ({ status }: { status: string }) => {
  const color: any = getColorByPaymentStatus(status);
  status = formatPaymentStatus(status);

  return (
    <Chip label={status} color={color} sx={{ color: "#fff", width: "100%" }} />
  );
};

export default PaymentStatusTag;
